import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material';
import { Router } from '@angular/router';
import { ClientesModalComponent } from '../modals/clientes-modal/clientes-modal.component';
import { ResgatarPontosModalComponent } from '../modals/resgatar-pontos-modal/resgatar-pontos-modal.component';
import { Cliente } from '../models/cliente';
import { FiExtrato } from '../models/movimenta-fidelidade';
import { CarregandoService } from '../services/carregando.service';
import { FidelidadeMovimentaService } from '../services/fidelidade-movimenta.service';
import { GlobalService } from '../services/global.service';
import { NotificacaoService } from '../services/notificacao.service';
import { PremissasService } from '../services/premissas.service';
import { UtilitarioService } from '../services/utilitario.service';
import { UsuarioLogado } from '../models/usuario-logado';

// jquery
declare const $: any;

@Component({
  selector: 'app-fidelidade',
  templateUrl: './fidelidade.component.html',
  styleUrls: ['./fidelidade.component.scss']
})
export class FidelidadeComponent implements OnInit {

  extrato: FiExtrato;
  carregando = true;
  usuario;
  selecionarIntegrador = true;
  integrador = false;
  cliente: Cliente;
  titulo = 'Programa de Fidelidade';

  usuarioLogado: UsuarioLogado;

  constructor(private carregandoService: CarregandoService, public utilitarioService: UtilitarioService, private globalService: GlobalService,
    private notificacaoService: NotificacaoService, private fidelidadeMovimentaService: FidelidadeMovimentaService, private router: Router,
    public dialog: MatDialog, private premissasService: PremissasService) { }

  async ngOnInit() {

    this.usuarioLogado = await this.globalService.consultaUsuario();
    this.integrador = await this.globalService.integrador();
  }

  buscarExtrato() {
    this.carregandoService.mostra('buscarExtrato');
    this.fidelidadeMovimentaService.consultarExtrato(this.cliente ? this.cliente.id : this.usuario).subscribe((data: any) => {
      this.extrato = data;
      this.carregando = false;
      this.carregandoService.esconde('buscarExtrato');
    }, (erro) => {
      this.carregandoService.esconde('buscarExtrato');
      this.notificacaoService.erro(erro);
    });
  }

  resgatar() {
    const largura = Number($('body').width());
    const dialogRef = this.dialog.open(ResgatarPontosModalComponent, {
      width: largura > 1230 ? '1200px' : (($('body').width()).toString() + 'px'),
      data: {
        saldo: this.extrato.saldo
      },
      panelClass: 'modal-card',
      maxHeight: '90vh',
    });

    dialogRef.afterClosed().subscribe((result: any) => {
      if (result) {
        this.carregandoService.mostra('resgatar');
        this.fidelidadeMovimentaService.resgatar(this.cliente ? this.cliente.id : this.usuario, result).subscribe((data: any) => {
          this.buscarExtrato();
          this.carregando = false;
          this.carregandoService.esconde('resgatar');
        }, (erro) => {
          this.carregandoService.esconde('resgatar');
          this.notificacaoService.erro(erro);
        });
      }
    });
  }

  pesquisarCliente() {
    const dialogRef = this.dialog.open(ClientesModalComponent, {
      width: ($('body').width()).toString() + 'px',
      data: {
        gi: 1,
        esconderBotao: true
      },
      panelClass: 'modal-card'
    });

    dialogRef.afterClosed().subscribe((result: any) => {
      if (result) {
        this.cliente = result.cliente;
        this.buscarExtrato();

      }
    }
    );
  }
}
